// extracted by mini-css-extract-plugin
export default {"navBox":"navbar_navBox__Slkd9","navbar":"navbar_navbar__a-EIN","content":"navbar_content__vHzYJ"};